import React from 'react';
import { StyledContentEditable } from './styles';

type Props = {
  value?: string;
  onCommit: (next: string) => void;
  placeholder?: string;
};

const ApprovalNoteCell: React.FC<Props> = ({
  value,
  onCommit,
  placeholder,
}) => {
  const hasContent = Boolean(value);
  const displayText = value || '';
  const effectivePlaceholder = placeholder ?? 'Click to add note...';

  return (
    <StyledContentEditable
      contentEditable
      suppressContentEditableWarning
      onBlur={(e) => {
        e.currentTarget.style.border = '1px solid transparent';
        e.currentTarget.style.backgroundColor = 'transparent';
        const content = (e.currentTarget.textContent || '').trim();
        const previous = (value || '').trim();
        if (content !== previous) {
          onCommit(content);
        }
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
      onFocus={(e) => {
        e.currentTarget.style.backgroundColor = 'transparent';
        e.currentTarget.style.color = 'inherit';
        if (!hasContent) {
          e.currentTarget.textContent = '';
        }
      }}
      onKeyDown={(e) => {
        e.stopPropagation();
        if (e.key === 'Enter') {
          e.preventDefault();
          (e.currentTarget as HTMLElement).blur();
        }
      }}
      onKeyUp={(e) => {
        e.stopPropagation();
      }}
      style={{
        color: hasContent ? 'inherit' : '#999',
      }}
      data-placeholder={hasContent ? '' : effectivePlaceholder}
    >
      {displayText}
    </StyledContentEditable>
  );
};

export default ApprovalNoteCell;
